<template>
    <div>
        <NoteTypes
            :types="parsedNoteTypes"
            :selected-types.sync="selectedTypes"
            :is-disabled="isLoading"
        />

        <Notification v-if="! noteTypes">
            Loading...
        </Notification>

        <Notification v-else-if="! parsedNoteTypes.length">
            No documents found.
        </Notification>

        <div
            v-else-if="! notes"
            class="columns is-multiline"
        >
            <SkeletonCard
                :count="4"
                :classes="classes"
            />
        </div>

        <Notification v-else-if="! hasNotes">
            No documents found.
        </Notification>

        <div
            v-else
            class="columns is-multiline"
        >
            <Note
                v-for="note in notes.Rows"
                :key="note.NotePK"
                :note="note"
                :class="classes"
            />
        </div>

        <b-pagination
            v-if="hasNotes && notes.RowCount > limit"
            class="mt-3"
            :total="notes.RowCount"
            :current.sync="page"
            order="is-centered"
            range-before="2"
            range-after="2"
            :per-page="limit"
            @change="searchNotes(false)"
        />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Notification from './Notification.vue';
import Note from './Note.vue';
import SkeletonCard from './SkeletonCard.vue';
import NoteTypes from './NoteTypes.vue';

export default {
    components: {
        Notification,
        Note,
        SkeletonCard,
        NoteTypes,
    },

    props: {
        classes: {
            type: String,
            default: 'is-12',
        },
        types: {
            type: Array,
            default: () => [],
        },
    },

    data: function() {
        return {
            page: Number(this.$route.query.page || 1),
            limit: 12,
            selectedTypes: [],
            isLoading: false,
        };
    },

    computed: {
        ...mapState('leaseholdProperty', [
            'notes',
            'noteTypes',
        ]),
        ...mapGetters('leaseholdProperty', [
            'hasNotes',
            'parsedNoteTypes',
        ]),
    },

    watch: {
        selectedTypes: function () {
            this.searchNotes();
        },
    },

    mounted() {
        this.$store.dispatch('leaseholdProperty/getNoteTypes');
    },

    methods: {
        searchNotes(resetPagination = true) {
            this.isLoading = true;

            if (resetPagination) {
                this.page = 1;
            }

            this.$router.push({
                query: this.$data,
            });

            this.getNotes()
            .then(() => {
                this.isLoading = false;
            });
        },
        getNotes() {
            return this.$store.dispatch('leaseholdProperty/getNotes', this.$data);
        },
    },
};
</script>
